import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import MessageUI from '../../widgets/output/MessageUI'
import SpinnerUI from '../../widgets/output/SpinnerUI'
import LRTableActionsUI from '../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../widgets/action/IconButtonUI'
import IconButtonLinkUI from '../../widgets/action/IconButtonLinkUI'
import './AccountList.css'

const AccountListUI = ({context, messageList, accountList, onRefreshClick,
    onConnectClick, connectingAccountId,
    onDisconnectClick, disconnectingAccountId,
    onSwitchClick, switchingAccountId
  }) =>
  <div className='ca_accs'>
    <LRTableActionsUI
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
        />
      }
      right={<span />}
    />

    <div className='inner'>
      {
        accountList.map((account, i) =>
          <React.Fragment key={i}>
            <AccountUI context={context} account={account} messageList={messageList}
              connectingAccountId={connectingAccountId} onConnectClick={onConnectClick}
              onDisconnectClick={onDisconnectClick} disconnectingAccountId={disconnectingAccountId}
              onSwitchClick={onSwitchClick} switchingAccountId={switchingAccountId}
            />
            {
              i === 0 && false &&
              <CreateUI context={context} messageList={messageList} />
            }
          </React.Fragment>
        )
      }
    </div>
  </div>

const AccountUI = ({context, account, messageList,
    onConnectClick, connectingAccountId,
    onDisconnectClick, disconnectingAccountId,
    onSwitchClick, switchingAccountId
  }) =>
  <div className={`item ${account.status}`}>
    <div className='internal'>
      <div className='g_flex_h line1'>
        <h4>
          {account.accountName}
        </h4>

        {(() => {
          switch (account.status) {
            case 'active':
              return <span className='g_muted g_small'>{account.roleName}</span>
            case 'blocked':
              return <MessageUI className='g_muted g_small' messageList={messageList} messageKey='c_disconnected' />
            // case 'inactive': such records should not be received from server
            //   return <MessageUI messageList={messageList} messageKey='c_disconnected' />
            case 'invited':
              return <div className='icon icon-envelope'></div>
            default:
          }
        })()}
      </div>

      <div className='g_flex_h line2'>
        {(() => {
          switch (account.status) {
            case 'active':
              return <React.Fragment>
                  {
                    account.accountId !== context.session.accountId &&
                    <React.Fragment>
                      <div className='g_flex_h action'>
                        <Link onClick={onSwitchClick} to='#switch' data-account-id={account.accountId}>
                          <MessageUI messageList={messageList} messageKey='c_switch_to_account' />
                        </Link>
                        <SpinnerUI show={account.accountId === switchingAccountId} />
                      </div>
                      {
                        // account owner cannot leave account
                        ! account.accountOwner &&
                        <LinkWithBusyUI context={context} account={account}
                          messageList={messageList} messageKey='c_disconnect_account'
                          onClick={onDisconnectClick} disconnectingAccountId={disconnectingAccountId}
                          connecting={false}
                        />
                      }
                    </React.Fragment>
                  }
                  {
                    account.accountId === context.session.accountId &&
                    <React.Fragment>
                      <MessageUI className='action' messageList={messageList} messageKey='c_current' />
                    </React.Fragment>
                  }
                </React.Fragment>
            case 'blocked':
              return <React.Fragment>
                  <span className='invisible'>.</span>
                  {
                    account.accountId !== context.session.accountId && // should always be true
                    <LinkWithBusyUI context={context} account={account}
                      messageList={messageList} messageKey='c_reconnect_account'
                      onClick={onConnectClick} connectingAccountId={connectingAccountId}
                      connecting={true}
                    />
                  }
                  {
                    account.accountId === context.session.accountId && // should always be false
                    <MessageUI className='action' messageList={messageList} messageKey='c_current' />
                  }
                </React.Fragment>
            case 'invited':
              return <React.Fragment>
                  {
                    account.accountId !== context.session.accountId && // should always be true
                    <React.Fragment>
                      <LinkWithBusyUI context={context} account={account}
                        messageList={messageList} messageKey='c_decline_invite'
                        onClick={onDisconnectClick} disconnectingAccountId={disconnectingAccountId}
                        connecting={false} rightSpinner={true}
                      />
                      <LinkWithBusyUI context={context} account={account}
                        messageList={messageList} messageKey='c_accept_invite'
                        onClick={onConnectClick} connectingAccountId={connectingAccountId}
                        connecting={true}
                      />
                    </React.Fragment>
                  }
                  {
                    account.accountId === context.session.accountId && // should always be false
                    <MessageUI className='action' messageList={messageList} messageKey='c_current' />
                  }
                </React.Fragment>
            default:
          }
        })()}
      </div>
    </div>
  </div>

const LinkWithBusyUI = ({context, account, messageList, messageKey, onClick, connectingAccountId, disconnectingAccountId, connecting, rightSpinner}) =>
  <div className='g_flex_h action'>
    {
      !rightSpinner &&
      <SpinnerUI show={(connecting && account.accountId === connectingAccountId) ||
        (!connecting && account.accountId === disconnectingAccountId)} />
    }
    <Link onClick={onClick} to='#' data-account-id={account.accountId}>
      <MessageUI messageList={messageList} messageKey={messageKey} />
    </Link>
    {
      rightSpinner &&
      <SpinnerUI show={(connecting && account.accountId === connectingAccountId) ||
        (!connecting && account.accountId === disconnectingAccountId)} />
    }
  </div>

const ActionLeftUI = ({context, messageList, onRefreshClick}) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    <IconButtonLinkUI messageList={messageList} icon='icon-plus' to='/settings/user/teams/create' labelKey='c_create_account' />
  </div>

const CreateUI = ({context, messageList}) =>
  <div className='item create'>
    <div className='internal'>
      <div className='g_flex_h line1'>
        <h4>
          <MessageUI messageList={messageList} messageKey='c_create_account' />
        </h4>
        <div className='icon icon-plus g_muted'></div>
      </div>
      <div className='g_flex_h line2'>
        <span className='invisible'>.</span>
        <Link to='/settings/user/teams/create'>
          <MessageUI messageList={messageList} messageKey='c_create_account' />
        </Link>
      </div>
    </div>
  </div>


export default withRouter(AccountListUI)
